export default "/cross.2ee50da32224da939c91f1a302c80b08.svg";